import axios from "axios";
import css from "../index.module.css";
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";
import usePush from "@hooks/usePush";

export default function Settings() {
  const { userData, refreshUserData, logout } = useUserData();
  const { subscribe, isSubscribed, isApp, isLoading, error } = usePush();

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    axios
      .post(`${import.meta.env.VITE_API_URL}/user`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((_) => {
        toast.success("Данные успешно обновлены");
        refreshUserData();
      })
      .catch((_) => {
        toast.error("Ошибка обновления данных");
      });
  };

  return (
    <div className={css.col1}>
        <div className={css.accountInfo}>
            <form className={css.form} onSubmit={handleSubmit}>
            <div className={css.flex}>
                <b className={css.headAcc}>Личные данные</b>
                <label>Имя</label>
                <input
                type="text"
                name="firstName"
                defaultValue={userData.firstName}
                placeholder="Имя"
                />
                <label>Фамилия</label>
                <input
                type="text"
                name="lastName"
                defaultValue={userData.lastName}
                placeholder="Фамилия"
                />
                <label>Имя пользователя</label>
                <input
                type="text"
                name="username"
                defaultValue={userData.username}
                placeholder="Имя пользователя"
                />
            </div>

            <button>Сохранить информацию</button>
            <a
                onClick={logout}
                style={{
                color: "#000",
                cursor: "pointer",
                background: "#fff",
                border: "1px solid #00000075",
                padding: "10px",
                borderRadius: 10,
                textAlign: "center",
                display: "block",
                marginTop: 0,
                }}
            >
                Выйти из аккаунта
            </a>

            <b className={css.headAcc} style={{ marginTop: 20}}>Уведомления</b>

            {isSubscribed &&
                <div className={css.notificationSubscribed}>
                <i className="fi fi-rr-check-circle"></i>
                <span>Уведомления подключены</span>
                </div>
            }

            {!isSubscribed && !isApp && (
                <button
                type="button"
                onClick={() => subscribe()}
                disabled={isLoading}
                >
                <i
                    className="fi fi-rr-bell"
                    style={{
                    marginRight: 10,
                    top: 2.5,
                    position: "relative",
                    }}
                />
                Включить PUSH-уведомления
                </button>
            )}
            {error && <span>{error}</span>}
            </form>
        </div>
    </div>
  );
}
